require('./ctxCarousel.style.scss');

class CtxCarouselController {
    constructor($scope, $element, $attrs, $timeout, $q) {
        this.$scope = $scope;
        this.$element = $element;
        this.$attrs = $attrs;
        this.$timeout = $timeout;
        this.$q = $q;
        this.activeIndicators = angular.isDefined(this.$attrs.activeIndicators) ? this.$attrs.activeIndicators === '' : false;
        this.activeControls = angular.isDefined(this.$attrs.activeControls) ? this.$attrs.activeControls === '' : false;
        this.carouselId = this.$attrs.carouselId || 'ctx-carousel';
        this.items = [];
    }

    $onInit() {
        this.onInit && this.onInit({ $event: { carousel: this } });
        this.$scope.$watch(() => this.isVisibleFlag, isVisibleFlag => {
            if (angular.isUndefined(isVisibleFlag)) return;
            if (!isVisibleFlag) {
                this.$element.find(`#${this.carouselId} .carousel-inner`).height('');
                this.$timeout(() => {
                    this.goTo(0);
                }, 500);
            }
            else {
                if (isVisibleFlag === 'RESET') {
                    return this.goTo(this.startIndex ? this.startIndex : 0);
                }
                if (this.onChange) {
                    this.onChange({ $event: { index: (this.startIndex ? this.startIndex : 0) } });
                }
            }
        });

        this.$timeout(() => {
            this.animateHeight();
            this.disableAutoCycling();
            // on slide before => .bind('slide.bs.carousel', e => {})
            // on slide after  => .on('slide.bs.carousel', e => {})
            this.$element.find(`#${this.carouselId}`).on('slide.bs.carousel', e => {
                e.testId = this.$element.find('.active').index();
                e.testId = e.direction === 'left' ? e.testId + 1 : e.testId - 1;
                // && this.isVisibleFlag
                if (this.onChange) this.onChange({ $event: { index: e.testId } });
            });
        }, 0);
    }

    disableAutoCycling() {
        this.$element.find(`#${this.carouselId}`).carousel({
            interval: 0
        });
    }

    enableAutoCycling(interval) {
        this.$element.find(`#${this.carouselId}`).carousel({
            interval: interval
        });
    }

    animateHeight() {
        this.$element.find(`#${this.carouselId}`).on('slide.bs.carousel', e => {
            this.$timeout(() => {
                let nextHeight = $(e.relatedTarget).height();
                if (nextHeight > 0) {
                    let parentEL = this.$element.find('.active.item').parent();
                    parentEL.animate({
                        height: nextHeight
                    }, 500, () => {
                        this.$timeout(() => {
                            let carouselInner = this.$element.find(`#${this.carouselId} .carousel-inner`);
                            carouselInner.css({ height: "auto" });
                        }, 600)
                    });
                }
            }, this.customDelay ? this.customDelay : 0);
        });
    }

    prev() {
        this.$element.find(`#${this.carouselId}`).carousel('prev');
    }

    next() {
        this.$element.find(`#${this.carouselId}`).carousel('next');
    }

    goTo(index) {
        this.$element.find(`#${this.carouselId}`).carousel(index);
    }

    getIndex() {
        return this.$element.find('.active').index();
    }

    addItem(item) {
        this.items.push(item);
    }
}

const ctxCarouselComponent = {
    controller: CtxCarouselController,
    controllerAs: 'ctxCarouselCtrl',
    transclude: true,
    template: require('./ctxCarousel.template.html'),
    bindings: {
        onInit: '&?',
        onChange: '&?',
        isVisibleFlag: '=',
        customDelay: '<?',
        startIndex: '<?'
    }
};

CtxCarouselController.$inject = ['$scope', '$element', '$attrs', '$timeout', '$q'];

module.exports = ctxCarouselComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxCarousel/ctxCarousel.component.js